import * as R from "ramda"
import React from "react"
import styled from "styled-components"

const Container = styled.div``

interface HappyFoxProps {}

const HappyFox: React.FC<HappyFoxProps> = () => {
  const containerRef = React.useRef<HTMLDivElement>(null)

  const runScripts = (scripts) => {
    R.forEach((script: HTMLScriptElement) => {
      const src = script.innerText
      const fn = new Function("require", src)
      fn()
    }, scripts)
  }

  React.useEffect(() => {
    const scripts =
      containerRef &&
      containerRef.current &&
      containerRef.current.getElementsByTagName("script")

    runScripts(scripts)
  }, [])

  const HappyFoxStyles = `
    .hfc-chat-badge {
      width: 30px;
      height: 30px;
      position: fixed;
      inset: auto 20px 55px auto;
      background-image: url(https://i.imgur.com/tP6DJaz.png);
      background-size: 60%;
      background-repeat: no-repeat;
      background-position: 50% 60%;
      font-family: sans-serif;
      background-color: #f26722;
      border: 1px solid #eee;
      border-radius: 50%;
      cursor: pointer;
    }
    .hfc-chat-badge.loading {
      background-image: none;
      background-image: url(https://i.imgur.com/NwCw04N.png);
    }
    .hfc-hidden {
      display: none;
    }
    #hfc-frame.hfc-badge.hfc-badge__vertical.hfc-badge__compact {
      width: 30px !important;
      height: 30px;
      inset: auto 20px 55px auto;
    }

    @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (orientation: portrait) {
      .hfc-chat-badge,
      #hfc-frame.hfc-badge.hfc-badge__vertical.hfc-badge__compact {
        inset: calc(50% - 55px) 10px auto auto;
      }
    }
  `

  const HappyFoxScript = `
  window.HFCHAT_CONFIG = {
    EMBED_TOKEN: "6fef0b10-8009-11eb-b7e4-4f5c0c5339fb",
    ASSETS_URL: "https://widget.happyfoxchat.com/v2/visitor",
    options: {
      loadInstantly: true,
      customStyles:
        ".badge { height: initial; } .badge-image-container svg {display:none} .badge-image-container {background-image: url(https://i.imgur.com/tP6DJaz.png); background-size: cover; background-repeat: no-repeat; background-position: 50%; background-size: 60%; background-color: #f26722 !important; width: 30px; height: 30px; border: none; } .chat-container {background-image: url(https://i.imgur.com/9MbuaXI.png)} .titlebar {background-image: url(https://i.imgur.com/BKsdPXE.jpg); background-size: contain;background-position: 50%;background-repeat: no-repeat;} .title {display:none} .titlebar path {fill: #000} .titlebar .badge-image-container {display: none}",
    },
  };

  var loadWidget = function () {
    var scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.async = true;
    scriptTag.src = window.HFCHAT_CONFIG.ASSETS_URL + "/js/widget-loader.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(scriptTag, s);
  };

  var loadBadge = function () {
    var documentBody = document.querySelector("body");
    var customBadge = document.createElement("div");
    customBadge.classList.add("hfc-chat-badge");
    documentBody.appendChild(customBadge);
    customBadge.addEventListener("click", () => {
      loadWidget();
      customBadge.classList.add("loading");
    });
  };

  var timestamp = localStorage.getItem("timestamp");

  if (timestamp !== null) {
    // taking visiting-gap as 15 minutes
    var epochGap = 900;

    // convert timestamp to seconds
    var jsTimestamp = new Date(Number(timestamp)).getTime() / 1000;
    var currentTimestamp = new Date().getTime() / 1000;
    console.log(currentTimestamp, jsTimestamp + epochGap, timestamp);

    // Mark visitor as returning if coming after the visiting-gap
    if (currentTimestamp > jsTimestamp + epochGap) {
      loadBadge();
      console.log("loading widget");
    }
  }

  if (localStorage.getItem("timestamp") == null) {
    var timestamp = new Date().getTime();
    localStorage.setItem("timestamp", timestamp);
  }

  HFCHAT_CONFIG.onload = function () {
    var HappyFoxChat = this;
    var customBadge = document.querySelector(".hfc-chat-badge");
    customBadge.classList.add("hfc-hidden");
    HappyFoxChat.expandChatbox();
    let attachments = [];
    HappyFoxChat.on("sent:visitor_message", function (e) {
      let message = e;
      if (message.url) {
        attachments.push(e);
        attachmentsList = attachments.map(
          (element) =>
            '<li><a target="_blank" href="' + element.url + '">' + element.name + '</a></li>'
        );
        HappyFoxChat.setCustomFields(
          {
            attachments: '<ul>' + attachmentsList + '</ul>',
          },
          function (err, resp) {
            if (err) {
              console.error(
                "Failed to add given properties to custom fields. Error:",
                err
              );
            } else {
              console.log("Added custom field properties:", resp);
            }
          }
        );
      }
    });
    HappyFoxChat.on("end:chat", function () {
      let attachments = [];
    });
  };
  `

  return (
    <Container
      dangerouslySetInnerHTML={{
        __html: `<style>${HappyFoxStyles}</style><script>${HappyFoxScript}</script>`,
      }}
      id="HappyFoxContainer"
      ref={containerRef}
    />
  )
}

export default HappyFox
